import Button from '@/components/shared/Button';
import HomeIcon from '@/svg/home-icon.svg';
import SellIcon from '@/svg/sell-icon.svg';
import Link from '@/components/shared/Link';
import { useSetSelectedServiceValueFormState } from '@/atoms/form/selected-service-value-form-state';
import { useSetFeedbackPopupDataNameState } from '@/components/general/FeedbackPopup/use-feedback-popup-data-name-atom';
import { FEEDBACK_POPUP_NAME } from '@/components/general/FeedbackPopup/FeedbackPopup';
import { useSetOpenedPopupsState } from '@/atoms/opened-popups';
import { YD_NEW_ID } from '@/metrics/ym';
import { FAVORITES_POPUP_NAME } from '@/components/shared/FavoritesPopup/FavoritesPopup';
import FavouritesWhiteIcon from '@/svg/favourites-white.svg';
import CurrencyDropdown from '@/components/shared/CurrencyDropdown';
import { useNavProductDataState } from '@/atoms/product-nav-state';
import { toCurrency } from '@/utils/to-currency';
import { useRoubleToDollarCourseState } from '@/atoms/rouble-to-dollar-course';
import { useSetSelectedItemsState } from '@/atoms/form/selected-items-state';
import CompareSVG from '@/svg/compare-empty-black.svg';
import ViewedSVGBlack from '@/svg/viewed-black.svg';
import PhoneSVG from '@/svg/phone.svg';

const CatalogFiltersProduct = () => {
    const setServiceValueFormState = useSetSelectedServiceValueFormState();
    const setFeedbackPopupDataName = useSetFeedbackPopupDataNameState();
    const { openPopup } = useSetOpenedPopupsState();
    const [navData] = useNavProductDataState();
    const [course] = useRoubleToDollarCourseState();

    const prices = navData.price ? [toCurrency(navData.price * course, 'RUB'), toCurrency(navData.price, 'USD')] : [];
    const setSelectedItems = useSetSelectedItemsState();

    return (
        <div className="catalog-filter-product filter-product">
            <div className="filter-product__left">
                <Button variant="primary" className="filter-product__btn-left" tag={Link} href="/" size="sm">
                    <HomeIcon />
                    Главная
                </Button>
                <Button
                    variant="primary"
                    className="filter-product__btn-left"
                    size="sm"
                    onClick={() => {
                        setServiceValueFormState('под заказ');
                        setFeedbackPopupDataName('order');
                        openPopup(FEEDBACK_POPUP_NAME);
                        window.ym?.(YD_NEW_ID, 'reachGoal', 'click_on_request');
                    }}
                >
                    <SellIcon />
                    Продать
                </Button>
                <Button
                    variant="primary"
                    className="filter-product__btn-left"
                    size="sm"
                    onClick={() => {
                        openPopup(FAVORITES_POPUP_NAME);
                    }}
                >
                    <FavouritesWhiteIcon />
                    Избранное
                </Button>
            </div>
            <div className="filter-product__right">
                <CurrencyDropdown prices={prices} classname="filter-product__dropdown" />
                <Button
                    className="filter-product__buy"
                    variant="primary"
                    onClick={() => {
                        setServiceValueFormState('Купить');
                        setSelectedItems([navData.title]);
                        setFeedbackPopupDataName('empty');
                        openPopup(FEEDBACK_POPUP_NAME);
                        window.ym?.(YD_NEW_ID, 'reachGoal', 'click_on_the_buy_button');
                    }}
                >
                    Купить
                </Button>
                <Button
                    tag={Link}
                    href="/compare"
                    variant="primary"
                    className="filter-product__right-btn filter-product__right-btn--compare"
                    size="sm"
                    icon={<CompareSVG />}
                    aria-label="перейти к сравнению"
                ></Button>
                <Button
                    tag={Link}
                    href={'/viewed'}
                    variant="primary"
                    className="filter-product__right-btn filter-product__right-btn--viewed"
                    size="sm"
                    icon={<ViewedSVGBlack />}
                    aria-label="перейти к просматриваемым"
                ></Button>
                <Button
                    variant="primary"
                    className="filter-product__right-btn filter-product__right-btn--feedback"
                    size="sm"
                    icon={<PhoneSVG />}
                    aria-label="Форма обратной связи"
                    onClick={() => {
                        setServiceValueFormState('под заказ');
                        setFeedbackPopupDataName('order');
                        openPopup(FEEDBACK_POPUP_NAME);
                        window.ym?.(YD_NEW_ID, 'reachGoal', 'click_on_request');
                    }}
                ></Button>
            </div>
        </div>
    );
};

export default CatalogFiltersProduct;
